import { OnInit } from "@angular/core";
var ButtonComponent = /** @class */ (function () {
    function ButtonComponent() {
    }
    ButtonComponent.prototype.ngOnInit = function () { };
    return ButtonComponent;
}());
export { ButtonComponent };
